import {Box, Flex, Text} from '@chakra-ui/react';
import {useInfiniteQuery} from '@tanstack/react-query';
import {getRestaurantsByRatings} from 'api/requests';
import {InfinityScrollButton} from 'components/shared';
import {FC, Fragment} from 'react';
import {TranslationKeys} from 'translations';
import {QueryKeyEnum} from 'types';
import ImageUI from 'ui/ImageUI';

import {ReviewItem} from './components/review-item';

interface IProps {
  providerName: string;
  providerSlug: string;
  t: (term: TranslationKeys) => string;
}

export const Reviews: FC<IProps> = ({providerSlug, t, providerName}) => {
  const {
    data: ratings,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: [QueryKeyEnum.RESTAURANT_BY_RATINGS, providerSlug],
    queryFn: ({pageParam = 0}) =>
      getRestaurantsByRatings({
        slug: providerSlug,
        offset: pageParam,
        limit: 5,
      }),
    getNextPageParam: (lastPage: any) => {
      if (lastPage?.next && typeof lastPage?.next === 'string') {
        return parseInt(lastPage.next.split('offset=')[1]);
      }
      return null;
    },
  });

  return (
    <Flex flexDirection="column" justifyContent="center" minH="455px" w="100%">
      {ratings?.pages &&
        ratings.pages.map((item, index) => {
          const reviews = item.results;

          return (
            <Fragment key={index}>
              {reviews &&
                reviews.map((review, index) => {
                  return <ReviewItem review={review} key={index} />;
                })}
              {!reviews && (
                <Flex key="no-reviews" alignSelf="center" flexDirection="column" alignItems="center">
                  <ImageUI src="/icons/noRatings.svg" alt="no-ratings" />
                  <Text>
                    {providerName} {t('PROVIDER_NO_REVIEWS')}
                  </Text>
                </Flex>
              )}
            </Fragment>
          );
        })}
      {hasNextPage && (
        <Box>
          <InfinityScrollButton
            fetchNextPage={fetchNextPage}
            isFetchingNextPage={isFetchingNextPage}
            providerPageCount={ratings?.pages.length}
          />
        </Box>
      )}
    </Flex>
  );
};
